import { Box, BoxProps } from '@mui/material';

import { DeviceHullType } from '@/api/devices/types';
import { SpotterFamily } from '@/common/types';
import { SCOUT_ICONS, SPOTTER_ICONS } from '@/components/map/SpotterMap';

export type DeviceIconProps = {
    spotterFamily: SpotterFamily;
    hullType?: DeviceHullType;
} & Omit<BoxProps<'img'>, 'component' | 'src' | 'alt'>;

export const DeviceIcon = ({ spotterFamily, hullType, ...boxProps }: DeviceIconProps) => {
    const src = hullType === 'scout' ? SCOUT_ICONS[spotterFamily] : SPOTTER_ICONS[spotterFamily].img;

    return <Box component="img" src={src} alt="Spotter" {...boxProps} />;
};
